export default "__VITE_ASSET__c0b6c2ce__"